module.exports = __webpack_public_path__ + "img/bettine.e39b8319.jpg";